var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAhu2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60mm",
    height: "20mm",
    viewBox: "0 0 60 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.817 3.9688h21.99v13.229h-21.99z",
    style: {
      fontVariationSettings: "'wght' 400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.641 17.206a6.6146 6.6146 0 0 0-6.5913-6.6223l-8e-3 -1.8e-5 -0.0155 6.6146 6.6146 0.01552z",
    style: {
      fontVariationSettings: "'wght' 400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.807 3.9688h12.156v6.6146h-12.156z",
    style: {
      fontVariationSettings: "'wght' 400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.563 10.591a6.6146 6.6146 0 0 0-6.5913-6.6223l-8e-3 -1.8e-5 -0.0155 6.6146 6.6146 0.01552z",
    style: {
      fontVariationSettings: "'wght' 400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.963 10.591h6.5993v6.6068h-6.5993z",
    style: {
      fontVariationSettings: "'wght' 400"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 18.536114,
    y: 13.229171,
    fill: "#000000",
    fontFamily: "Quicksand",
    fontSize: "7.0556px",
    stroke: "#000000",
    strokeWidth: 0.5,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 18.536114,
    y: 13.229171,
    fill: "#000000",
    fontFamily: "Quicksand",
    fontSize: "7.0556px",
    strokeWidth: 0.5,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "AHU")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.244 11.906h-6.6146v-1.3229l-2.6458 2.6458 2.6458 2.6458v-1.3229h6.6146z",
    fill: "#f00",
    stroke: "#000",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3.984 9.2604 6.6146 5.4e-5 -1.1e-5 1.3229 2.6459-2.6458-2.6458-2.6459-1.1e-5 1.3229-6.6146-5.4e-5z",
    fill: "#000eff",
    stroke: "#000",
    strokeWidth: 0.3
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.807,
    y: 10.583,
    width: 4.2187,
    height: 6.6146,
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhu2);
export default __webpack_public_path__ + "static/media/ahu2.de2f27f2f5bb0eb5eddb7a6ee7a2531b.svg";
export { ForwardRef as ReactComponent };